import React from "react";
import { observer } from "mobx-react";
import { EditionDocumentTypeUpdateStore } from "../../store";
import { EditionDocumentTypeUpdateForm } from "./EditionDocumentTypeUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type EditionDocumentTypeUpdateProps = {
  editionDocumentTypeUpdateStore: EditionDocumentTypeUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const EditionDocumentTypeUpdate: React.FC<EditionDocumentTypeUpdateProps> =
  observer(
    ({
      editionDocumentTypeUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={editionDocumentTypeUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={editionDocumentTypeUpdateStore.savedButOutdated}
            onReload={() =>
              editionDocumentTypeUpdateStore.reloadEditionDocumentType()
            }
            reloadDisabled={editionDocumentTypeUpdateStore.isProcessing}
          />
          <EditionDocumentTypeUpdateForm
            editionDocumentTypeUpdateStore={editionDocumentTypeUpdateStore}
            nameError={editionDocumentTypeUpdateStore.errors.name?.message}
            onNameChange={(value: string) => {
              editionDocumentTypeUpdateStore.setNameValue(value);
            }}
            name={editionDocumentTypeUpdateStore.entityValues.name}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={editionDocumentTypeUpdateStore.saveDisabled}
            onSave={() =>
              editionDocumentTypeUpdateStore.saveEditionDocumentType()
            }
            onCancel={() =>
              editionDocumentTypeUpdateStore.cancelEditionDocumentType()
            }
          />
          <ErrorDialog
            open={editionDocumentTypeUpdateStore.errorDialogOpened}
            title={editionDocumentTypeUpdateStore.errorTitle}
            description={editionDocumentTypeUpdateStore.errorDescription}
            onClose={() => editionDocumentTypeUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={editionDocumentTypeUpdateStore.confirmDialogOpened}
            title={editionDocumentTypeUpdateStore.confirmDialogTitle}
            description={
              editionDocumentTypeUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              editionDocumentTypeUpdateStore.executeConfirmedAction()
            }
            onCancel={() => editionDocumentTypeUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
